"use client";

import { useEffect } from "react";
import { handleEvent } from "./util";

export const TrackWrapper = ({
  children,
  event,
}: {
  component: React.ComponentType<any>;
  event: {
    name: string;
    properties: Record<string, any>;
  };
}) => {
  useEffect(() => {
    handleEvent(event);
  }, []);
  return children;
};
